import React from 'react'
import PropTypes from 'prop-types'
import ModalFooter from 'components/ModalFooter'
import ModalHeader from 'components/ModalHeader'

import Prepare from './Prepare'
import { StyledModal } from './component.styles'

const KickoffModal = ({ handleClose, handleNextButtonClick, modals }) => {
  const { helpCopy, nextLabel } = modals[1]
  console.log('modals', modals)

  return (
    <StyledModal
      dataTestId="kickoff-modal"
      isModalOpen={true}
      modalClose={() => handleClose}
    >
      <ModalHeader handleClose={handleClose} showBackButton={false} />
      <Prepare modalData={modals[1]} />
      <ModalFooter
        handleNextButtonClick={handleNextButtonClick}
        helpCopy={helpCopy}
        isValid={true}
        modalName="kickoff"
        nextButtonText={nextLabel}
        showCancelButton={false}
      />
    </StyledModal>
  )
}

KickoffModal.propTypes = {
  currentStep: PropTypes.number,
  handleClose: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  modals: PropTypes.array,
}

export default KickoffModal
